import { PreviewTabIndex } from '~/App/Components/RecorderDrawer/Components/Preview';
import createPersistedState from '~/react-hooks/use-persisted-state';
const previewTabIndexHook = createPersistedState('preview-tab-index');

export interface PreviewTabIndexProps {
  index: PreviewTabIndex;
  setIndex: (index: PreviewTabIndex) => void;
}

export function usePreviewTabIndex(
  defaultIndex: PreviewTabIndex = PreviewTabIndex.Record
) {
  const [index, setIndex] = previewTabIndexHook<PreviewTabIndex>(defaultIndex);

  return {
    index,
    setIndex,
  } as PreviewTabIndexProps;
}
